import SingleChangelog from "./single-changelog";

export default SingleChangelog;
